import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IFrame } from 'framework-plugins';
import Helmet from 'react-helmet';

const Firme = ({ ufficio }) => {
  return (
    <React.Fragment>
      <Helmet title="Firme" />
      <IFrame
        src={window.config.urlFirme}
        srcParams={{ ufficio }}
      />
    </React.Fragment>
  );
};

Firme.propTypes = {
  ufficio: PropTypes.string.isRequired,
};

const mapStoreToProps = store => ({
  ufficio: store.utente.ufficioSelezionato.CodiceUfficio,
});

Firme.propTypes = {
  ufficio: PropTypes.string.isRequired,
};

export default connect(mapStoreToProps)(Firme);
